<template>
  <div @click.stop="() => { }" class="upload-search" :style="{ '--width-w': width, '--height-h': height }">
    <el-upload ref="uploadRef" :disabled="state.loading || uploadLoading" class="upload-demo" action drag
      :show-file-list="false" :http-request="handleUpLoad" accept=".jpg, .jpeg, .png, .webp"
      :before-upload="beforeUpload">
      <img v-if="state.loading || uploadLoading" src="@/assets/images/home/loading.gif" class="loading" />
      <img v-else-if="state.searchImg" class="search-img-cl-show" :src="state.searchImg"
        @error="state.searchImg && (state.searchImg = '')" alt />
      <img v-else src="@/assets/images/icons/picture.svg" class="pd-tupian panda" />
      <!-- <el-icon v-else :size="20" >
        <PictureFilled />
      </el-icon> -->
    </el-upload>
  </div>
</template>

<script setup>
import { ElMessage } from 'element-plus';
import {
  getImgBase64,
  dataURLtoBlob,
  getBlobToUrl,
  objToFormdata
} from '@/utils/searchImg';
import { getBase64ToImageId } from '@/apis/goods';
import { getLocalSearchImg } from '@/utils/searchImg';
import { reactive, watch, defineEmits, defineProps } from 'vue';
import { useRoute } from 'vue-router';

defineProps({
  width: {
    type: String,
    default: '50px'
  },
  height: {
    type: String,
    default: '50px'
  },
  uploadLoading: {
    type: Boolean,
    default: false
  }
});
const $route = useRoute();
const $emit = defineEmits(['base64ImgToSearch']);
const state = reactive({
  // maxSize: 1920*1080,
  maxSize: 1024 * 100,
  fileTypes: ['image/png', 'image/jpg', 'image/jpeg'],
  input: undefined,
  loading: false,
  searchImg: '',
  disabled: true
});

const beforeUpload = (file) => {
  const suffix = file.name.slice(file.name.lastIndexOf('.'))
  if (['.jpg', '.jpeg', '.png', '.webp'].includes(suffix)) {
    return true
  }
  return false
}
const handleUpLoad = async ({ file }) => {
  try {
    state.loading = true;
    let base64 = await getImgBase64(file);

    const url = getBlobToUrl(dataURLtoBlob(base64));
    base64 = base64.slice(base64.indexOf('base64,') + 7);
    const res = await getBase64ToImageId(objToFormdata({ base64 }));

    state.searchImg = url;

    $emit('base64ImgToSearch', {
      base64,
      imageId: res.imageInfo.AL,
      imageId2: res.imageInfo.TB,
      url
    });
  } catch (error) {
    ElMessage({ type: 'error', message: error });
  } finally {
    state.loading = false;
  }
};
watch(
  () => $route.path,
  () => {

    if ($route.path !== '/search-list') {
      state.searchImg = '';
    } else {
      if ($route.query.imageId) {
        state.searchImg = getLocalSearchImg();
      } else {
        state.searchImg = ''
      }
    }
  },

  { immediate: true }
);

watch(
  () => $route.query.imageId,
  () => {
    // if ($route.query.imageId) {
    //     state.searchImg = getLocalSearchImg();
    //   }
  }
);
</script>

<style lang="scss" scoped>
.upload-search {
  .upload-demo {
    display: block;
    width: var(--width-w);
    height: var(--height-h);
  }

  ::v-deep {
    .el-upload-dragger {
      width: var(--width-w);
      height: var(--height-h);
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      background-color: transparent;
      padding: 0;

      .pd-tupian {
        font-size: 50px;
        width: 20px;
        height: 20px;
      }

      .loading {
        width: 20;
        height: 20px;
      }
    }
  }

  .search-img-cl-show {
    width: 100%;
    height: 100%;
  }
}
</style>
